<div class="attachment-config-container" role="main">
  <!-- Breadcrumb -->
  <nav class="breadcrumb-wrapper" aria-label="Navigazione breadcrumb">
    <p-breadcrumb [model]="breadcrumbItems()" [home]="{ icon: 'pi pi-home', routerLink: '/' }" />
  </nav>

  <!-- Main Card -->
  <div class="config-card">
    <h1 class="page-title" id="page-title">Nuova configurazione allegati</h1>

    <!-- Form Section -->
    <form class="form-section" aria-labelledby="page-title">
      <div class="form-row">
        <div class="form-field">
          <label for="config-title">Titolo configurazione allegati</label>
          <input
            id="config-title"
            type="text"
            pInputText
            [(ngModel)]="configTitle"
            placeholder="Inserisci titolo..."
            class="w-full"
            aria-required="true"
            aria-label="Titolo configurazione allegati"
          />
        </div>

        <div class="form-field">
          <label for="category">Seleziona categoria fiduciario</label>
          <p-select
            id="category"
            [options]="categoryOptions"
            [(ngModel)]="selectedCategory"
            optionLabel="label"
            placeholder="-- Categoria fiduciario--"
            [style]="{ width: '100%' }"
            aria-label="Seleziona categoria fiduciario"
            aria-required="true"
          />
        </div>

        <div class="form-field checkbox-field">
          <label for="active">Attivo</label>
          <p-checkbox
            id="active"
            [(ngModel)]="isActive"
            [binary]="true"
            aria-label="Rendi configurazione attiva"
          />
        </div>
      </div>

      <!-- Add Field Button -->
      <div class="add-field-section">
        <p-button
          label="Aggiungi campo"
          icon="pi pi-plus-circle"
          (onClick)="onAddField()"
          styleClass="p-button-primary"
          ariaLabel="Aggiungi nuovo campo allegato"
          title="Aggiungi nuovo campo allegato"
        />
      </div>
    </form>

    <!-- Table Section -->
    <div class="table-section" role="region" aria-labelledby="table-caption">
      <h2 id="table-caption" class="sr-only">Elenco campi allegati</h2>
      <p-table
        [value]="attachmentFields()"
        [loading]="loading()"
        styleClass="p-datatable-sm"
        ariaLabel="Tabella campi allegati configurabili"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="col-ordine" scope="col">ORDINE</th>
            <th class="col-nome" scope="col">NOME CAMPO</th>
            <th class="col-template" scope="col">TEMPLATE DA COMPILARE</th>
            <th class="col-obbligatorio" scope="col">OBBLIGATORIO</th>
            <th class="col-azioni" scope="col">AZIONI</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-field>
          <tr>
            <td class="col-ordine">
              <div
                class="order-controls"
                role="group"
                [attr.aria-label]="'Riordina campo ' + field.fieldName"
              >
                <button
                  pButton
                  type="button"
                  icon="pi pi-chevron-up"
                  class="p-button-text p-button-sm"
                  (click)="onMoveUp(field)"
                  [attr.aria-label]="'Sposta su ' + field.fieldName"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-chevron-down"
                  class="p-button-text p-button-sm"
                  (click)="onMoveDown(field)"
                  [attr.aria-label]="'Sposta giù ' + field.fieldName"
                ></button>
              </div>
            </td>
            <td class="col-nome">
              <label [for]="'field-name-' + field.id" class="sr-only"
                >Nome campo per {{ field.fieldName || 'nuovo campo' }}</label
              >
              <input
                [id]="'field-name-' + field.id"
                type="text"
                pInputText
                [(ngModel)]="field.fieldName"
                placeholder="Nome campo"
                class="w-full"
                [attr.aria-label]="'Nome campo per ' + (field.fieldName || 'nuovo campo')"
                aria-required="true"
              />
            </td>
            <td class="col-template">
              <div class="file-upload-container">
                <input
                  [id]="'file-input-' + field.id"
                  type="file"
                  #fileInput
                  (change)="onFileSelect($event, field)"
                  style="display: none"
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                  [attr.aria-label]="'Carica template per ' + field.fieldName"
                />
                @if (field.templateFileName) {
                  <div
                    class="file-info"
                    role="group"
                    [attr.aria-label]="'File allegato: ' + field.templateFileName"
                  >
                    <span class="file-name" aria-live="polite">{{ field.templateFileName }}</span>
                    <button
                      pButton
                      type="button"
                      icon="pi pi-times"
                      class="p-button-text p-button-sm p-button-danger"
                      (click)="onRemoveFile(field)"
                      pTooltip="Rimuovi file"
                      [attr.aria-label]="'Rimuovi file ' + field.templateFileName"
                    ></button>
                  </div>
                } @else {
                  <p-button
                    label="Sfoglia..."
                    icon="pi pi-upload"
                    (onClick)="fileInput.click()"
                    styleClass="p-button-secondary p-button-sm"
                    [ariaLabel]="'Sfoglia e carica template per ' + field.fieldName"
                    [title]="'Sfoglia e carica template per ' + field.fieldName"
                  />
                }
              </div>
            </td>
            <td class="col-obbligatorio">
              <label [for]="'required-' + field.id" class="sr-only"
                >Campo obbligatorio per {{ field.fieldName }}</label
              >
              <p-checkbox
                [id]="'required-' + field.id"
                [(ngModel)]="field.required"
                [binary]="true"
                [attr.aria-label]="'Rendi obbligatorio il campo ' + field.fieldName"
              />
            </td>
            <td class="col-azioni">
              <div
                class="action-buttons"
                role="group"
                [attr.aria-label]="'Azioni per ' + field.fieldName"
              >
                <p-button
                  icon="pi pi-trash"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (onClick)="onDeleteField(field)"
                  pTooltip="Elimina"
                  [ariaLabel]="'Elimina campo ' + field.fieldName"
                  [title]="'Elimina campo ' + field.fieldName"
                />
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center" role="status" aria-live="polite">
              Nessun campo allegato configurato.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Action Buttons -->
    <div class="action-section">
      <p-button
        label="Salva"
        icon="pi pi-save"
        (onClick)="onSave()"
        styleClass="p-button-primary"
        ariaLabel="Salva configurazione allegati"
        title="Salva configurazione allegati"
      />
    </div>
  </div>

  <!-- Toast for notifications -->
  <p-toast role="status" aria-live="polite" aria-atomic="true" />
</div>
